import React from "react";
import { withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";
import withSnackbar from "../../util/withSnackbar";
import Button from '@mui/material/Button';
import _ from 'lodash';
import { COGNITO_EXCEPTION_WORDING_MAPPER } from '../../constants/CognitoErrorConstants';
import { SNACKBAR_OPTIONS, TIMEOUT } from '../../constants/CommonConstants';
import Header from "../CeHeader/Header";
import { LinearProgress } from '@mui/material';
import cognitoAuth from '../../util/Cognito';
import CompletionDialog from "../Common/CompletionDialog";
import { errorHandle } from '../../Common/errorHandle';
import "./CeAddCustomer.css";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import IconButton from '@mui/material/IconButton';
import { StyledList,StyledListItem,StyledIconButton } from "../Common/muiOverrideStyle"
import AddIcon from '@mui/icons-material/Add';


// config serial number length (must be 0 or 13)
const serialNumberLengthLimit = {
    min: 0,
    max: 13
};

class CeAddCustomer extends React.Component {

    constructor(props) {
        super(props);
        this.validateInput = this.validateInput.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.state = {
            showChangePassword: this.props.location.state ? this.props.location.state.isInitialLogin : false,
            showLmsSetting: this.props.location.state ? !this.props.location.state.isActivated : false,
            email: '',
            userName: '',
            error: '',
            warning: '',
            serialNumbers: [''],
            authorizer: '',
            successDisplay: 'none',
            isProgress: false,
            isExistedCustomerSelect: false,
            isAPIError: false,
            isKMCE: false,
            systemList: ["JobManager","Ultimate SI","both", "JobManagerSchedule"],
            selectedSystemIndex: 3,
            serialNumberVaild: true,
            isScheduleSwitchOn : true,
            isFluxSwitchOn:false
        }
    };

    validateInput() {
        let error = '';

        if (this.state.isExistedCustomerSelect && (!this.state.userName)) {
            // 空の入力フォームがあった場合は、エラーとする（既存顧客追加）
            error = error.concat(this.props.intl.formatMessage({ id: "fields_compulsory" }))
            return error;
        } else if (!this.state.isExistedCustomerSelect && (!this.state.userName || !this.state.email)) {
            // シリアルナンバーを除いて、空の入力フォームがあった場合は、エラーとする（新規顧客追加）
            error = error.concat(this.props.intl.formatMessage({ id: "fields_compulsory" }))
            return error;
        } else {
            let emailValidation = /\S+@\S+\.\S+/;
            let userNameValidation = /^[A-Za-z0-9_.\-@]+$/;
            let checkAuthorizer = this.state.authorizerDisplay === 'block';
            let isUserNameValid = userNameValidation.test(this.state.userName);
            let isEMailValid = emailValidation.test(this.state.email);
            let isAuthorizerValid = emailValidation.test(this.state.authorizer);

            if (!isEMailValid && !this.state.isExistedCustomerSelect) {
                error = error.concat(this.props.intl.formatMessage({ id: "email_error" }));
            }
            if (checkAuthorizer && !isAuthorizerValid) {
                error = error.concat(this.props.intl.formatMessage({ id: "authorizer_email_error" }));
            }
            if (!isUserNameValid && !this.state.isExistedCustomerSelect) {
                error = error.concat(this.props.intl.formatMessage({ id: "username_error" }));
            }
            const uppercaseSerialNumbers = this.state.serialNumbers.map((v) => v.toUpperCase());
            if (!uppercaseSerialNumbers.every((v, i, self) => self.indexOf(v) === i) && !this.state.isExistedCustomerSelect) {
                error = error.concat(this.props.intl.formatMessage({ id: "serial_number_duplicate_error" }));
            }
        }
        return error;
    }

    register() {
        if (this.state.isProgress) return;
        //remove any '' present in serialNumbers
        let serialNumbers = [...this.state.serialNumbers];
        serialNumbers = serialNumbers.filter(sn => sn !== '');

        let error = this.validateInput();

        this.setState(prevState => {
            return {
                error: error,
                serialNumbers: serialNumbers.length ? serialNumbers : prevState.serialNumbers,
                isAPIError: false
            }
        });
        let paramsObj = {
            userId: this.state.userName,
            tenantId: this.state.userName,
            mailAddress: this.state.email,
            authorizer: this.state.authorizer,
            machineList: serialNumbers,
            isNewService: !this.state.isExistedCustomerSelect,
            isLocation: this.state.isLocation,
        }
        if (this.state.selectedSystemIndex ===  3 && !this.state.isExistedCustomerSelect){
            paramsObj.isIncludeSchedule = this.state.isScheduleSwitchOn;
            paramsObj.isFlux = this.state.isFluxSwitchOn;
        }
        if (error === '') {
            let header = {
                'Authorization': '',
                'Content-Type': 'application/json'
            };
            this.setState({ isProgress: true });
            cognitoAuth.getAuthorizationToken().then((token) => {
                header.Authorization = token;
            }, (error) => {
                this.setState({ isProgress: false });
                throw error;
            }).then(() => {
                const controller = new AbortController();
                const props = this;
                const timer = window.setTimeout(errorHandle(function () {
                    controller.abort();
                    throw props;
                }), TIMEOUT);

                if (this.state.isExistedCustomerSelect) {
                    return this.addCeUser(header,paramsObj,controller,timer)
                } else {
                    const { selectedSystemIndex } = this.state;
                    let system = "";
                    if (selectedSystemIndex === 2){
                        system= ["JobManager","Ultimate SI"];
                    }else{
                        system= this.state.systemList[selectedSystemIndex];
                    }
                    if(typeof(system) !== 'string'){
                        system.map(sys => {
                            paramsObj["feature"] = sys;
                            return this.addCeUser(header,paramsObj,controller,timer)
                        })
                    }else{
                        paramsObj["feature"] =  system;
                        return this.addCeUser(header,paramsObj,controller,timer);
                    }   
                }
            });
        }
    }

    // add ce user
    addCeUser = (header,paramsObj,controller,timer) => {
        for (let key in paramsObj.machineList) {
            paramsObj.machineList[key] = paramsObj.machineList[key].toUpperCase()
        }
        fetch(process.env.REACT_APP_CE_USER, {
            method: "POST",
            headers: header,
            signal: controller.signal,
            body: JSON.stringify(paramsObj),
        }).then(res => {
            window.clearTimeout(timer);
            if (res.ok) {
                this.setState({
                    isCompleteDialog: true,
                });
            } else {
                this.setState({ isAPIError: true });
            }
            return res.json();
        }).then(res => {
            if (this.state.isAPIError) {
                if (res.status !== 500) {
                    this.setState({ error: this.props.intl.formatMessage({ id: COGNITO_EXCEPTION_WORDING_MAPPER[res.code] }) })
                } else {
                    this.props.openSnackbar(this.props.intl.formatMessage({ id: "server_error" }));
                }
            } else {
                if (res.status === "approved") {
                    this.setState({
                        isKMCE: true
                    });
                }
            }
        }).finally(() => {
            this.setState({ isProgress: false });
        });
    }
    onClickAddSN() {
        if (this.state.isExistedCustomerSelect) return;
        let serialNumbers = this.state.serialNumbers;
        serialNumbers.push('')
        this.setState({ serialNumbers: serialNumbers });
    }

    onSnChange(i, sn) {
        let serialNumbers = this.state.serialNumbers;
        serialNumbers[i] = sn;
        this.setState({ serialNumbers: serialNumbers }, () => this.validateSerialNumberLength());
    }

    onClickDeleteButton(i) {
        let serialNumbers = this.state.serialNumbers;
        if (!this.state.selectedSystemIndex === 0 || serialNumbers.length === 1) {
            return;
        }
        serialNumbers.splice(i, 1);
        this.setState({ serialNumbers: serialNumbers }, () => this.validateSerialNumberLength())
    }

    onEmailChange(value) {
        this.setState({ email: value })
    }

    onUserNameChange(value) {
        this.setState({ userName: value })
    }

    onEmailValidation(event) {
        let regexp = /^[A-Za-z0-9_.\-@]+$/;
        let str = event.target.value;
        if (!regexp.test(str)) {
            str = str.split('').filter((char) => regexp.test(char) === true).join('')
            event.target.value = str;
        }
    }

    onUserIdValidation(event) {
        let regexp = /^[A-Za-z0-9_.\-@]+$/;
        let str = event.target.value;
        if (!regexp.test(str)) {
            str = str.split('').filter((char) => regexp.test(char) === true).join('')
            event.target.value = str;
        }
    }

    onSerialNumberValidation(event) {
        let regexp = /^[A-Za-z0-9]+$/;
        let str = event.target.value;
        if (!regexp.test(str)) {
            str = str.split('').filter((char) => regexp.test(char) === true).join('')
            event.target.value = str;
        }
    }

    handleClose() {
        // 入力情報をクリア
        this.setState({
            isCompleteDialog: false,
            email: '',
            userName: '',
            authorizer: '',
            serialNumbers: [''],
            selectedSystemIndex: 3
        });
        // 前画面に戻る
        this.props.history.goBack();
    }

    onChangeRadioButton(isDisabled) {
        this.setState({
            email: '',
            userName: '',
            authorizer: '',
            serialNumbers: [''],
            isExistedCustomerSelect: isDisabled,
            selectedSystemIndex: 3
        });
    }

    SortedAscendingIcon = () => {
        return <img src="/assets/img/dandori/img_sortArrow.svg" style={{ transform: "scale(1,-1)" }} />;
    };

    handleCheckBoxChanged = (selectedSystemIndex) => {
        let machineNumberList = [...this.state.serialNumbers];
        if (selectedSystemIndex === 0 || selectedSystemIndex === 3) {
            machineNumberList = [''];
        }
        this.setState({
            selectedSystemIndex: selectedSystemIndex,
            serialNumbers: [...machineNumberList],
            isScheduleSwitchOn : true,
        })
    }

    // Create for checking Serial Number Length
    validateSerialNumberLength() {
        const { min, max } = serialNumberLengthLimit;
        const validItems = this.state.serialNumbers.filter(item => item.length === min || item.length === max);
        if (validItems.length !== this.state.serialNumbers.length) {
            if (this.state.serialNumberVaild) {
                this.setState({
                    serialNumberVaild: false
                });
            }
        } else {
            if (!this.state.serialNumberVaild) {
                this.setState({
                    serialNumberVaild: true
                })
            }
        }
    }

    // Get SN input class
    getSnInputClass(i) {
        const serialNumbers = this.state.serialNumbers[i];
        if (this.state.isExistedCustomerSelect || !this.state.selectedSystemIndex > 0) {
            return "machineInput disabled";
        } else if (serialNumbers.length !== serialNumberLengthLimit.min && serialNumbers.length !== serialNumberLengthLimit.max ) {
            return "machineInput withLengthError";
        } else {
            return "machineInput";
        }
    }
    getRadioLabel(system){
        let label = "";
        switch (system) {
            case "JobManager":
                label = "JobManager";
                break;
            case "Ultimate SI":
                label = "Op-Analysis";
                break;
            case "both":
                label = this.props.intl.formatMessage({ id: "ce_addCustomers_JMAndAQA_title" });
                break;
            case "JobManagerSchedule":
                label = this.props.intl.formatMessage({ id: "ce_addCustomers_ScheduleJM_title" });
                break;
            default:
                break;
        }
        return label;
    }

    render() {
        const { systemList,selectedSystemIndex, serialNumbers } = this.state;
        return (
            <div id="ceAddCustomer" className="body">
                {this.state.isProgress ? <LinearProgress /> : ''}
                <Header showSubMenu={true} />
                <div className="ceAdd-content">
                    <div className="ceAdd-title">{this.props.intl.formatMessage({ id: "ce_add_addCustomers_title" })}</div>
                    <div className="ceAdd-customer-select">
                        <FormControl>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                            >
                                <FormControlLabel 
                                    checked={!this.state.isExistedCustomerSelect} 
                                    onChange={() => this.onChangeRadioButton(false)} 
                                    classes={{ root: "ceAddLabelRoot" }} 
                                    value="new" 
                                    control={
                                        <Radio 
                                            classes={{ root: "ceAddRadioRoot" }} 
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 16 } }} 
                                        />} 
                                    label={this.props.intl.formatMessage({ id: "add_new_customer" })} 
                                />
                                <FormControlLabel 
                                    value="update" 
                                    onChange={() => this.onChangeRadioButton(true)} 
                                    classes={{ root: "ceAddLabelRoot" }} 
                                    control={
                                        <Radio 
                                            classes={{ root: "ceAddRadioRoot" }} 
                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 16 } }} 
                                        />} 
                                    label={this.props.intl.formatMessage({ id: "add_existed_customer" })}
                                />
                            </RadioGroup>
                        </FormControl>
                        <FormGroup row={true} classes={{ root: !this.state.isExistedCustomerSelect ? "ceAddFormGroupRoot" : "ceAddFormGroupHiddenRoot" }}>
                            {systemList.map((system,index) => {
                                return <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                        >
                                            <FormControlLabel 
                                                classes={{ root: "ceAddLabelRoot ceAddCheckboxLabelRoot" }}
                                                label={this.getRadioLabel(system)}
                                                control={
                                                    <Radio 
                                                        checked={index === selectedSystemIndex} 
                                                        onChange={() => this.handleCheckBoxChanged(index)}
                                                        classes={{ root: "ceAddCheckRoot" }} 
                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 16 } }} 
                                                    />
                                                } 
                                            />
                                        </RadioGroup>
                                })}
                        </FormGroup>
                    </div>
                    <div className="customerInfo">
                        <div className="customerInfo-title">{this.props.intl.formatMessage({ id: "ce_edit_customerInfo" })}</div>
                        <div className="customerInfo-content">
                            <div className="basicInfo">
                                <div className="labelSet">
                                    <span>
                                        {this.props.intl.formatMessage({ id: "add_customer_email_address" })}
                                        {this.state.isExistedCustomerSelect===false?<span className="required">*</span>:null}
                                    </span>
                                    <div className={this.state.isExistedCustomerSelect ? "inputField disabled" : "inputField"}>
                                        <input type="email" disabled={this.state.isExistedCustomerSelect} name="email" size="45" maxLength="128" value={this.state.email} onInput={event => { this.onEmailValidation(event) }} onChange={event => this.onEmailChange(event.target.value)} />
                                    </div>
                                </div>
                                <div className="labelSet">
                                    <span>
                                        {this.props.intl.formatMessage({ id: "add_customer_user_id" })}
                                        <span className="required">*</span>
                                    </span>
                                    <div className={"inputField"}>
                                        <input type="text" name="userName" value={this.state.userName} maxLength="40" size="45" onInput={event => { this.onUserIdValidation(event) }} onChange={event => this.onUserNameChange(event.target.value)} />
                                    </div>
                                </div>
                            </div>
                            <div className={selectedSystemIndex !== 1 && selectedSystemIndex !== 3  && !this.state.isExistedCustomerSelect ? "basicInfo" : "basicInfo-hidden"}>
                                <div className="switch-beta">
                                    <input
                                        type="checkbox"
                                        checked={this.state.isLocation}
                                        onChange={(event) => this.setState({isLocation: event.target.checked})}
                                    />
                                    <span>{this.props.intl.formatMessage({id: "ce_location_on_off"})}</span>
                                </div>
                            </div>
                            <div className={!this.state.isExistedCustomerSelect && selectedSystemIndex === 3 ? "scheduleSwitch" : "scheduleSwitch-hidden"}>
                                <div className="scheduleSwitchSetting">
                                    <input
                                        type="checkbox"
                                        checked={this.state.isScheduleSwitchOn}
                                        style={{cursor:"default"}}//schedule可编辑时需要删除此样式
                                        disabled
                                    />
                                    <div className="labelSet">
                                        <span style={{fontSize:"16px"}}>{this.props.intl.formatMessage({ id: "ce_addCustomers_Schedule_switch_label" })}</span>
                                    </div>
                                </div>
                                
                                <div className="scheduleSwitchSetting">
                                    <input
                                        type="checkbox"
                                        checked={this.state.isFluxSwitchOn}
                                        onChange={(e) => this.setState({ isFluxSwitchOn: e.target.checked })}
                                    />
                                    <div className="labelSet">
                                        <span style={{fontSize:"16px"}}>{this.props.intl.formatMessage({ id: "ce_addCustomers_flux_switch_label" })}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={![1, 2].includes(selectedSystemIndex) || this.state.isExistedCustomerSelect ? "machine-hidden" : "machine-show"}>
                        <div className="machine-btn">
                            <div className="machineList-title">{this.props.intl.formatMessage({ id: "ce_serial_number_list" })}</div>
                            <Button id="ceButton" variant="outlined"  onClick={() => this.onClickAddSN()} className="machine-button" startIcon={<AddIcon classes={{root:"ceAddIconRoot"}} sx={{ fontSize: 24 }} />}>
                                {this.props.intl.formatMessage({ id: "ce_edit_addSerialNumber" })}
                            </Button>
                        </div>
                        <div className="machine-list">
                            <div className="machine-title">{this.props.intl.formatMessage({ id: "ce_edit_serialNumber" })}</div>
                            <div className="machine-content">
                                    <List sx={StyledList}>
                                        {_.times(this.state.serialNumbers.length, (i) => (
                                            <ListItem
                                               sx={StyledListItem}
                                                key={i}
                                                disableGutters
                                                secondaryAction={
                                                    <IconButton  
                                                        sx={StyledIconButton} 
                                                        aria-label="comment" 
                                                        classes={{root: "machineDeleteBtnRoot"}} 
                                                        onClick={() => this.onClickDeleteButton(i)}
                                                        disabled={serialNumbers.length === 1}
                                                    >
                                                        <img className={serialNumbers.length === 1 ? "delete-icon delete-icon-disabled" : "delete-icon"} src="/assets/img/icon_recycle_bin_24.svg" alt="icon_delete" />
                                                    </IconButton>
                                                }
                                            >
                                                <input
                                                    id="serialNumberInput"
                                                    type="text"
                                                    disabled={this.state.isExistedCustomerSelect}
                                                    name="serialNumber"
                                                    value={this.state.serialNumbers[i]}
                                                    size="45"
                                                    className={this.getSnInputClass(i)}
                                                    onInput={(event) => {
                                                        this.onSerialNumberValidation(event);
                                                    }}
                                                    onChange={(event) => {
                                                        this.onSnChange(i, event.target.value);
                                                    }}
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                           
                            </div>
                            {/* Error message for SN length */}
                            {
                                !this.state.serialNumberVaild && (
                                    <p className="serialNumber-error-message">
                                        <ErrorOutlineIcon color="error" />
                                        {
                                            this.props.intl.formatMessage({id: "ce_sn_validation"})
                                        }
                                    </p>
                                )
                            }
                        </div>
                    </div>
                    
                    <div className="ceAdd-btn">
                        <div>
                            <div className="errMsg"><span>{this.state.error}</span></div>
                            <div className="warnMsg"><span>{this.state.warning}</span></div>
                        </div>
                        <Button disabled={this.state.isProgress || !this.state.serialNumberVaild} fullWidth id="registerButton" className={this.state.isProgress || !this.state.serialNumberVaild ? "disabledBtn register-btn" :"register-btn"} onClick={() => this.register()}>{this.props.intl.formatMessage({ id: "register" })}</Button>
                        <Button sx={{color:"rgba(0, 0, 0, 0.87)"}} disabled={this.state.isProgress} fullWidth className={this.state.isProgress ? "back-btn disabledBtn" : "back-btn"} id="registerButton" onClick={() => this.props.history.goBack()}>{this.props.intl.formatMessage({ id: "go_back" })}</Button>
                    </div>
                </div>
                <div className="success-contents" style={{display: this.state.successDisplay}}>
                    {/* TODO: Change "registered" icon */}
                    <img alt="km_logo" src="/assets/img/km_logo.svg"/>
                    <div>{this.props.intl.formatMessage({ id: "registered" })}</div>
                </div>
                <CompletionDialog 
                    show={this.state.isCompleteDialog}
                    handleClose={this.handleClose}
                    intl={this.props.intl}
                    message={!this.state.isKMCE && this.state.isExistedCustomerSelect ? "ce_user_account_complete_dealer" : "ce_user_account_complete_kmce"}
                />
            </div>
        )
    }

}

export default withSnackbar(withRouter(injectIntl(CeAddCustomer)), SNACKBAR_OPTIONS);